<template>
    <li class="book-reviews-item" v-if="item">
        <div class="user-data">
            <img :src="getImgPic()" alt="" />
            <span class="user-name">{{ item.author.nickname }}</span>
            <span class="user-lv">Lv.{{ item.author.lv }}</span>
            <p class="score"><van-rate v-model="value" readonly size="12px" /></p>
        </div>
        <div class="review-content">
            <h5 v-if="item.title">{{ item.title }}</h5>
            <p class="content">{{ item.content }}</p>
        </div>
        <div class="describe">
            <span class="time" v-if="item.updated">{{ timeMaker(item.updated) }}</span>
            <span class="discuss" v-if="item.commentCount"><van-icon name="chat" />{{ item.commentCount }}</span>
            <span class="like"><van-icon name="good-job" />{{ item.likeCount }}</span>
        </div>
    </li>
</template>

<script>
export default {
    props: ["item"],
    data() {
        return {
            imgPic: ["/img/home1.07658490.jpg", "/img/home2.b3ba88da.jpg", "/img/home3.cce529dc.jpg", "/img/home4.29b765c2.jpg", "/img/home5.28ef859a.jpg", "/img/home6.8165fb12.jpg"],
            value: this.item.rating
        };
    },
    methods: {
        getImgPic() {
            let n = Math.floor(Math.random() * this.imgPic.length);
            return this.imgPic[n];
        },
        timeMaker(t) {
            var date = new Date(t); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var now = new Date();

            var Y = date.getFullYear();
            var M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var D = date.getDate();
            var h = date.getHours();
            var m = date.getMinutes();
            var s = date.getSeconds();
            var NY = now.getFullYear();
            var NM = now.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var ND = now.getDate();
            var Nh = now.getHours();
            var Nm = now.getMinutes();
            var Ns = now.getSeconds();

            if (NY - Y > 0) {
                return NY - Y + "年前更新";
            } else if (NM - M > 0) {
                return NM - M + "月前更新";
            } else if (ND - D > 0) {
                return ND - D + "天前更新";
            } else if (Nh - h > 0) {
                return Nh - h + "时前更新";
            } else if (Nm - m > 0) {
                return Nm - m + "分前更新";
            } else if (Ns - s > 0) {
                return Ns - s + "秒前更新";
            }
            // this.bookDetails.updated = Y + M + D + h + m + s;
        }
    }
};
</script>

<style lang="less">
li.book-reviews-item {
    border-bottom: 1px solid rgb(241, 241, 241);
    padding: 15px 0 35px;
    .user-data {
        padding: 0 15px;
        img {
            position: relative;
            top: -5px;
            width: 8vw;
            height: 8vw;
            border-radius: 50%;
        }
        span {
            color: #666;
            font-size: 12px;
            vertical-align: top;
            &.user-name {
                margin: 0 15px;
            }
            &.user-lv {
                border-radius: 5px;
                padding: 2px 3px;
                border: 1px solid rgb(241, 241, 241);
            }
        }
        p.score {
            margin: 0;
        }
    }
    .review-content {
        padding: 0 15px;

        h5 {
            margin: 10px 0;
        }
        p.content {
            font-size: 14px;
            color: #666;
            margin: 10px 0;
        }
    }
    .describe {
        padding: 0 15px;
        // display: flex;

        span {
            // flex: 1;
            color: #999;
            font-size: 10px;
            &.time {
            }
            &.discuss {
                float: right;
            }
            &.like {
                float: right;
                color: #999;
            }
        }
    }
}
</style>
